import { Component, input, output } from '@angular/core';
import { TransportStop } from '@/new-transport/_models/transport-map.model';

@Component({
	selector: 'app-map-destination',
	standalone: true,
	templateUrl: './map-destination.component.html',
	styleUrl: './map-destination.component.scss',
})
export class MapDestinationComponent {
	readonly destinations = input.required<TransportStop[]>();
	readonly vehicleInUseSelected = input.required<boolean>();

	readonly destinationSelected = output<number>();

	selectDestination(destination: number): void {
		this.destinationSelected.emit(destination);
	}
}
